// Scatola nera (S3): raccoglie gli errori del telefono, li tiene in memoria locale anche senza rete
// e li manda al database appena può. Non blocca mai l'app: se qualcosa qui fallisce, si ignora.

const CHIAVE = 'spa.scatolaNera';
const MAX = 200; // errori tenuti sul telefono al massimo (i più vecchi escono)
const MAX_TESTO = 2000;

function taglia(s) {
  const t = String(s ?? '');
  return t.length > MAX_TESTO ? t.slice(0, MAX_TESTO) + '…' : t;
}

export function descriviErrore(err, contesto = {}) {
  const e = err instanceof Error ? err : null;
  return {
    messaggio: taglia(e ? e.message : typeof err === 'string' ? err : JSON.stringify(err)),
    nome: e ? e.name : 'Errore',
    codice: (err && err.code) || null,
    pila: taglia(e && e.stack),
    contesto: taglia(JSON.stringify(contesto)),
  };
}

/**
 * @param {object} o
 * @param {Storage} [o.archivio] dove tenere gli errori non ancora mandati (localStorage)
 * @param {(lista: object[]) => Promise<void>} o.invia manda gli errori al database
 * @param {() => object} [o.info] dati utili aggiunti a ogni errore (versione, pagina, rete)
 */
export function creaScatolaNera({ archivio, invia, info = () => ({}), ora = () => Date.now() }) {
  let coda = leggi();
  let inInvio = false;

  function leggi() {
    try {
      const v = JSON.parse(archivio?.getItem(CHIAVE) || '[]');
      return Array.isArray(v) ? v : [];
    } catch {
      return [];
    }
  }
  function salva() {
    try {
      archivio?.setItem(CHIAVE, JSON.stringify(coda));
    } catch {
      // memoria piena: si tengono solo i più recenti
      coda = coda.slice(-Math.floor(MAX / 4));
      try { archivio?.setItem(CHIAVE, JSON.stringify(coda)); } catch { /* niente da fare */ }
    }
  }

  function registra(err, contesto) {
    try {
      let extra = {};
      try { extra = info() || {}; } catch { /* info rotta: si va avanti */ }
      const voce = { id: `${ora()}-${Math.random().toString(36).slice(2, 8)}`, quandoLocale: ora(), ...extra, ...descriviErrore(err, contesto) };
      coda.push(voce);
      if (coda.length > MAX) coda = coda.slice(-MAX);
      salva();
      return voce;
    } catch {
      return null;
    }
  }

  async function svuota() {
    if (inInvio || coda.length === 0) return 0;
    inInvio = true;
    const lotto = coda.slice(0, 20);
    try {
      await invia(lotto);
      const mandati = new Set(lotto.map((v) => v.id));
      coda = coda.filter((v) => !mandati.has(v.id));
      salva();
      return lotto.length;
    } catch {
      return 0; // riproverà alla prossima occasione
    } finally {
      inInvio = false;
    }
  }

  return { registra, svuota, inCoda: () => coda.length };
}

// Collega la scatola nera agli errori non gestiti della pagina.
export function ascoltaErroriPagina(scatola, finestra = globalThis) {
  finestra.addEventListener?.('error', (ev) => scatola.registra(ev.error || ev.message, { tipo: 'error', file: ev.filename, riga: ev.lineno }));
  finestra.addEventListener?.('unhandledrejection', (ev) => scatola.registra(ev.reason, { tipo: 'promessa' }));
  finestra.addEventListener?.('online', () => scatola.svuota());
}
